import { TScoreHistoryEntry } from '@/domains/scoring/score-history-policy';
import { scoreEntriesStyles } from '../ScoreHistoryCard.styles';
import { ScoreHistoryCardItem } from './ScoreHistoryCardItem';
import { TSimulationType } from '@/types';
import React from 'react';

/**
 * Props for the ScoreHistoryCardItemList component.
 */
interface ScoreHistoryCardItemListProps {
  /** Sorted, visible subset of score history entries to render. */
  entries: TScoreHistoryEntry[];
  /** HTML id forwarded to the list wrapper; used by the show-more button's aria-controls. */
  id?: string;
  /** The type of simulation, used to determine badge color per item. */
  simulationType?: TSimulationType;
}

/**
 * Renders the ordered list of visible score history entries.
 * Each entry is delegated to `ScoreHistoryCardItem` for its own layout and styling.
 */
export const ScoreHistoryCardItemList: React.FC<ScoreHistoryCardItemListProps> = ({
  entries,
  id,
  simulationType,
}) => (
  <div id={id} role="list" className={scoreEntriesStyles}>
    {entries.map((entry, index) => (
      <ScoreHistoryCardItem
        entry={entry}
        index={index}
        key={entry.id}
        simulationType={simulationType}
        visibleEntriesLength={entries.length}
      />
    ))}
  </div>
);

ScoreHistoryCardItemList.displayName = 'ScoreHistoryCardItemList';

export default ScoreHistoryCardItemList;
